// 날짜 포맷 (YYYY-MM-DD)
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
    date.getDate()
  ).padStart(2, '0')}`;
};

// 숫자 → 통화 포맷
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('ko-KR', { style: 'currency', currency: 'KRW' }).format(amount);
};

// 값이 비어있는지 체크
export const isEmpty = (value) => {
  return value === null || value === undefined || value === '';
};

export const saveMap = {
  '1': '1년',
  '3': '3년',
  '5': '5년',
  'z': '영구',
};
export const lineTypeMap = {
  lb: '결재',
  lc: '합의',
  ld: '담당',
  le: '수신',
};
export const lineTypeColorMap = {
  lb: 'bg-blue-custom',     // 결재 → 진한 파랑
  lc: 'bg-green-custom',    // 합의 → 선명한 초록
  ld: 'bg-yellow-custom',   // 담당 → 노랑
  le: 'bg-orange-custom',   // 수신 → 주황
};
export const publicTypeMap = {
  user: '개인',
  dept: '부서',
  all: '전체',
};
export const approvalActionMap = {
  approve: "승인",
  reject: "반려",
  agree: "찬성",
  disagree: "반대",
};
// ✅ 문서 상태 매핑
export const docStatusMap = {
  request: "진행중",
  complete: "완료",
  reject: "반려",
  draft: "임시저장",
};

// ✅ 결재문서 목록 타이틀
export const headerMap = {
  draft: "📝 작성중 결재문서",
  request: "📌 진행중 결재문서",
  complete: "📂 문서함",
  reject: "❌ 반려함",
};

/* -------------------- 📎 일정 관련 매핑 -------------------- */
// 📎 일정 유형
export const eventTypeMap = {
  W: '업무일정',
  S: '공유일정',
  M: '회의',
};

// 📎 메일 발송 여부
export const sendMailMap = {
  Y: '발송',
  N: '미발송',
};

// 📎 상태
export const statusMap = {
  register: '등록',
  request: '등록 대기',
  reject: '반려',
  draft: '회수',
  approve: '승인',
};

// 📎 참석 여부
export const attendanceMap = {
  Y: '참석',
  N: '미참석',
};


